var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuildingHomeHouse = function SvgBuildingHomeHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.625 17.5h-2.5a1.875 1.875 0 0 1-1.875-1.875V12.5a.625.625 0 0 0-.625-.625h-1.25a.625.625 0 0 0-.625.625v3.125A1.875 1.875 0 0 1 6.875 17.5h-2.5A1.875 1.875 0 0 1 2.5 15.625v-5.212A3.13 3.13 0 0 1 3.412 8.2L8.67 2.944a1.875 1.875 0 0 1 2.65 0L16.575 8.2a3.13 3.13 0 0 1 .925 2.213v5.212a1.875 1.875 0 0 1-1.875 1.875"
  })));
};
export default SvgBuildingHomeHouse;